import { render, staticRenderFns } from "./horizontalItem.vue?vue&type=template&id=405f665a&scoped=true&"
import script from "./horizontalItem.vue?vue&type=script&lang=js&"
export * from "./horizontalItem.vue?vue&type=script&lang=js&"
import style0 from "./horizontalItem.vue?vue&type=style&index=0&id=405f665a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405f665a",
  null
  
)

export default component.exports